import EmployeeDetail from "./EmployeeDetail";
import EmployeeHeader from "./EmployeeHeader";
import { EmployeeProvider } from "features/allocations/contexts/EmployeeContext";
import { EmployeeRowCellsProvider } from "features/allocations/contexts/EmployeeRowCellsContext";
import PropTypes from "prop-types";
import getEmployeeKey from "./utils/getEmployeeKey";

const Employee = ({ data }) => {
    return (
        <EmployeeProvider>
                <EmployeeRowCellsProvider>
                    <div id={"div_" + getEmployeeKey(data)} style={{borderTop: "1px solid black"}}>
                        <EmployeeHeader
                            id={"empheader_" + getEmployeeKey(data)}
                            key={"header_" + getEmployeeKey(data)}
                            initialData={data}
                        />
                        <EmployeeDetail
                            id={"empdetail_" + getEmployeeKey(data)}
                            details={data?.projects}
                            employee={data}
                        />
                    </div>
                </EmployeeRowCellsProvider>
        </EmployeeProvider>
    );
};

Employee.propTypes = {
    data: PropTypes.object.isRequired,
};

export default Employee;
